import React from 'react';
import SimpleMarkdown from 'simple-markdown';

// Decodes via a detached, never-mounted element — the browser's own entity
// decoder, without ever handing the entity to a live HTML sink.
function decodeHtmlEntity(entity: string): string {
  const el = document.createElement('textarea');
  el.innerHTML = entity;
  return el.value;
}

export const escapedCharacterRule = {
  order: SimpleMarkdown.defaultRules.em.order - 0.5,
  match: (source) => /^(&#?(?:[\w\d])+;)/.exec(source),
  parse: (capture) => {
    return {
      content: capture[1]
    };
  },
  react(node) {
    return <span key={node.tokenId}>{decodeHtmlEntity(node.content)}</span>;
  }
};
